import ApiClient from './ApiClient';

class CustomMessageTemplatesAPI extends ApiClient {
  constructor() {
    super('custom_message_templates', { accountScoped: true });
  }

  get(inboxId) {
    if (inboxId) {
      return window.axios.get(
        `${this.url}?inbox_id=${inboxId}&t=${Date.now()}`
      );
    }
    return window.axios.get(`${this.url}?t=${Date.now()}`);
  }

  create(data) {
    return window.axios.post(this.url, { custom_message_template: data });
  }

  update(id, data) {
    return window.axios.patch(`${this.url}/${id}`, {
      custom_message_template: data,
    });
  }

  destroy(id) {
    return window.axios.delete(`${this.url}/${id}`);
  }

  restore(id) {
    return window.axios.post(`${this.url}/${id}/restore`);
  }

  deleteFromMeta(id) {
    return window.axios.delete(`${this.url}/${id}/delete_from_meta`);
  }

  syncStatus(id) {
    return window.axios.post(`${this.url}/${id}/sync_status`);
  }

  releaseReview(id) {
    return window.axios.post(`${this.url}/${id}/release_review`);
  }

  destroyReview(id) {
    return window.axios.delete(`${this.url}/${id}/destroy_review`);
  }
}

export default new CustomMessageTemplatesAPI();
